
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mendable-api/overview",
      function () {
        return require("private-next-pages/mendable-api/overview.md");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mendable-api/overview"])
      });
    }
  